export default "__VITE_ASSET__ce6a29f7__"